import { getOrCreateGlobalSingleton } from '@backstage/version-bridge';

const routeRefType = getOrCreateGlobalSingleton(
  "route-ref-type",
  () => Symbol("route-ref-type")
);
function isRouteRef(routeRef) {
  return routeRef[routeRefType] === "absolute";
}
function isSubRouteRef(routeRef) {
  return routeRef[routeRefType] === "sub";
}
function isExternalRouteRef(routeRef) {
  return routeRef[routeRefType] === "external";
}

export { isExternalRouteRef, isRouteRef, isSubRouteRef, routeRefType };
//# sourceMappingURL=types.esm.js.map
